import { render, staticRenderFns } from "./UserPermissionForm.vue?vue&type=template&id=fd6aada8&scoped=true&"
import script from "./UserPermissionForm.vue?vue&type=script&lang=js&"
export * from "./UserPermissionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6aada8",
  null
  
)

export default component.exports